module.exports = __webpack_public_path__ + "static/media/chevron-left.6ac34632.svg";